<template>
  <div>
    <div
      class="mdgridviewpage-bg mainWrap-bg applicationListPage indicatorPage"
    >
      <!-- <HeaderNew></HeaderNew> -->
      <div class="container maindivWrap">
        <div class="row">
          <div class="col-12">
            <div class="row mx-0">
              <!-- <div
                class="px-0"
                :class="[
                  allAppsList.length === 0
                    ? 'col-sm-6 offset-sm-6'
                    : 'col-sm-8 offset-sm-4'
                ]"
              > -->
              <div class="col-12 px-0">
                <nav class="navbar navbar-expand-sm bg-light px-0">
                  <!-- Links -->
                  <ul class="navbar-nav justify-content-end w-100">
                    <li class="nav-item">
                      <a class="nav-link" href="#">
                        <form>
                          <div class="input-group mb-3">
                            <div class="input-group-prepend">
                              <span class="input-group-text">
                                <i class="fa fa-search" aria-hidden="true"></i>
                              </span>
                            </div>
                            <input
                              type="text"
                              class="form-control"
                              placeholder="Search..."
                              id
                              name
                              v-model="searchName"
                              style="border-left:0;"
                            />
                          </div>
                        </form>
                      </a>
                    </li>
                    <li class="nav-item">
                      <a class="nav-link" href="#">
                        <div class="btn btn-light btn-sm" type="button">
                          <i class="fa fa-th-large" aria-hidden="true"></i>
                        </div>
                      </a>
                    </li>
                    <li class="nav-item">
                      <a class="nav-link" href="#">
                        <div class="btn btn-light btn-sm" type="button">
                          <i class="fa fa-bars" aria-hidden="true"></i>
                        </div>
                      </a>
                    </li>
                    <li class="nav-item">
                      <a class="nav-link" href="#">
                        <form class="form-inline" action="/action_page.php">
                          <label for="" class="mr-sm-2">Show:</label>
                          <select class="form-control" id="sel1">
                            <option>10</option>
                            <option>50</option>
                            <option>100</option>
                            <option>500</option>
                          </select>
                        </form>
                      </a>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
          </div>

          <div class="col-sm-12">
            <div class="listingTable mb-4">
              <div class="row mx-0">
                <div class="col-12 px-0">
                  <div class="row">
                    <div class="col-6">
                      <h5 class="section_title mt-3">Alerts</h5>
                    </div>
                    <div class="col-6">
                      <button
                        class="btn btn-sm float-right addTemp_btn mt-3 mr-0"
                        @click = "showForm()"
                      >
                        <span class="border_bottom_grey" >
                          <i class="fa fa-plus" aria-hidden="true"></i> Add Alert
                        </span>
                      </button>
                    </div>
                  </div>
                  <div class="card tableCard">
                    <div class="card-body px-0 pt-2">
                      <table
                        class="table table-striped table-hover mb-0 bg-white shadow-sm"
                      >
                        <thead>
                          <tr class="row mx-0">
                            <th class="col-1" style="border-top: 0;">No.</th>
                            <th class="col-6" style="border-top: 0;">
                              Indicator Name
                            </th>

                            <th class="col-3" style="border-top: 0;">
                              Updated On
                            </th>
                            <th class="col-2" style="border-top: 0;">Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          <template v-for="alert,ind in allAlertList">
                            <tr class="row mx-0">
                              <td class="col-1">{{ind +1}}.</td>
                              <td class="col-6">{{alert.displayName}}</td>

                              <td class="col-3">{{alert.lastUpdated}}</td>
                              <td class="col-2">
                                <div class="iconGroup">
                                  <i
                                    class="fa fa-pencil-square-o"
                                    aria-hidden="true"
                                    v-b-tooltip.hover
                                    title="Edit" @click="editind(alert.displayName,alert.id)"
                                  ></i>

                                  <i
                                    class="fa fa-trash"
                                    aria-hidden="true"
                                    v-b-tooltip.hover
                                    title="Delete"  @click="deleteind(alert.id)"
                                  ></i>
                                </div>
                              </td>
                            </tr>
                          </template>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-12" v-if="showIndForm">
            <div class="wizardCard mb-4 " id="add_indicator">
              <div class="card shadow-sm">
                <div class="card-header">
                  Add Alert
                </div>
                <div class="card-body">
                  <div class="row mx-0 mb-2">
                    <div class="col-sm-12 mb-1">
                      <div class="form-group row mx-0">
                        <label
                          for="indicatorName"
                          class="col-sm-3 col-form-label"
                          >Alert Name</label
                        >
                        <div class="col-sm-9">
                          <input
                            type="text"
                            class="form-control"
                            id="indicatorName"
                            placeholder v-model="frmModel.name"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row mx-0 mb-2">
                    <div class="col-sm-12 mb-1">
                      <div class="form-group row mx-0">
                        <label
                          for="indicatorTypeName"
                          class="col-sm-3 col-form-label"
                          >Description</label
                        >
                        <div class="col-sm-9">
                          <input
                            type="text"
                            class="form-control"
                            id="indicatorTypeName"
                            placeholder v-model="frmModel.shortName"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row mx-0 mb-2">
                    <div class="col-sm-12 mb-1">
                      <div class="form-group row mx-0">
                        <label
                          for="indicatorTypeName"
                          class="col-sm-3 col-form-label"
                          >Period Type</label
                        >
                        <div class="col-sm-9">
                          <div class="dropdown">

                              <b-select
                              :options="periodTypeList"
                              v-model="frmModel.periodType"
                              >
                            </b-select>

                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row mx-0 mb-2">
                    <div class="col-sm-12 mb-1">
                      <div class="form-group row mx-0">
                        <label
                          for="operand"
                          class="col-sm-3 col-form-label"
                          >Select Operator</label
                        >
                        <div class="col-sm-9">
                          <div class="dropdown">

                              <b-select
                              :options="operandList"
                              v-model="frmModel.operator"
                              >
                            </b-select>

                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row mx-0 mb-2">
                    <div class="col-sm-12 mb-1">
                      <div class="form-group row mx-0">
                        <label
                          for="indicatorTypeName"
                          class="col-sm-12 col-form-label card-header mx-1 mb-0" style="padding: 7px 12px !important; border-radius: 8px 8px 0 0 !important;"
                          >Left Side / Right Side</label
                        >
                        <div class="col-sm-12">
                          <div class="tabsSelection">
                            <b-tabs pills card>
                              <b-tab title="Left Side Expression" active
                                ><b-card-text>
                                  <div class="">
                                    <div class="row mx-0 mb-2">
                                      <div class="col-sm-12 mb-1">
                                        <div class="form-group row mx-0">
                                          <label
                                            for="leftSideDescription"
                                            class="col-sm-2 col-form-label"
                                            >Description</label
                                          >
                                          <div class="col-sm-10">
                                            <input
                                              type="text"
                                              class="form-control"
                                              id="numeratorDescription"
                                              placeholder v-model="frmModel.leftSide.description"
                                            />
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div class="row mx-0 mb-2">
                                      <div class="col-sm-12 mb-1">
                                        <div class="form-group row mx-0">
                                          <!-- <label
                                            for="indicatorTypeName"
                                            class="col-sm-2 col-form-label"
                                            >Select Elements</label
                                          > -->
                                          <div class="col-sm-12">
                                            <div id="accordion">
                                              <div class="card rounded-0">
                                                <div
                                                  class=""
                                                  id="headingOne"
                                                  data-toggle="collapse"
                                                  data-target="#collapseOne"
                                                  aria-expanded="true"
                                                  aria-controls="collapseOne"
                                                >
                                                  <h5 class="mb-0">
                                                    <button
                                                      class="btn btn-light btn-block text-left bg_f4" style="border: 1px solid #ddd;"
                                                    >
                                                      Data Element
                                                    </button>
                                                  </h5>
                                                </div>

                                                <div
                                                  id="collapseOne"
                                                  class="collapse show"
                                                  aria-labelledby="headingOne"
                                                  data-parent="#accordion"
                                                >
                                                  <div
                                                    class="card-body pt-1 pb-0 px-0 rounded-0"
                                                  >
                                                    <div class="row">
                                                      <div class="col-sm-5">
                                                        <div class="row">
                                                          <div class="col-12 pr-0">
                                                            <div class="py-3 px-2" style="border-right:1px solid #ddd;">
                                                              <b-badge
                                                                variant="light"
                                                                class="px-3 mx-1" @click="addElem('(','(')"
                                                                >(</b-badge
                                                              >
                                                              <b-badge
                                                                variant="light"
                                                                class="px-3 mx-1" @click="addElem(')',')')"
                                                                >)</b-badge
                                                              >
                                                              <b-badge
                                                                variant="light"
                                                                class="px-3 mx-1" @click="addElem('*','*')"
                                                                >*</b-badge
                                                              >
                                                              <b-badge
                                                                variant="light"
                                                                class="px-3 mx-1" @click="addElem('/','/')"
                                                                >/</b-badge
                                                              >
                                                              <b-badge
                                                                variant="light"
                                                                class="px-3 mx-1" @click="addElem('+','+')"
                                                                >+</b-badge
                                                              >
                                                              <b-badge
                                                                variant="light"
                                                                class="px-3 mx-1" @click="addElem('-','-')"
                                                                >-</b-badge
                                                              >
                                                              <b-badge
                                                                variant="light"
                                                                class="px-3 mx-1" @click="addElem('[Days]','[Days]')"
                                                                >Days</b-badge
                                                              >
                                                            </div>
                                                          </div>
                                                          <div class="col-12 pr-0">
                                                            <div class="p-3 " style="border-top:1px solid #ddd; border-right:1px solid #ddd;" >
                                                              <textarea class="expressionBuilder form-control" v-model="expressionBuilder">
                                                              </textarea>
                                                              <div class="alertSection mt-3">
                                                                <b-alert show variant="success">Expression is <b>Valid</b></b-alert>
                                                                <b-alert show variant="danger">Expression is <b>not well-formed </b></b-alert>
                                                              </div>
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                      <div class="col-sm-7">
                                                        <div
                                                          class="swipTextWrap"
                                                        >
                                                          <div class="form-group has-search mt-3 w-100">
                                                            <span class="fa fa-search form-control-feedback"></span>
                                                            <input type="text" class="form-control" placeholder="Search" v-model="serachoptionslist">
                                                          </div>
                                                          <select
                                                            multiple   class="form-control multiSelectOption border border-0 mb-2 px-0" >
                                                            <template v-for="elem,i in dataElementList">
                                                            <option :value="elem.id" @click="addElem(elem.id,elem.displayName,'DataElem')">
                                                              {{elem.displayName}}
                                                            </option>
                                                          </template>
                                                          </select>

                                                          </select>
                                                          <!-- <a
                                                            class="text-success checkValid"
                                                            >Valid</a
                                                          > -->
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <!-- <div class="row mx-0 mb-2">
                                      <div
                                        class="justify-content-end d-flex w-100"
                                      >
                                        <button class="btn btn-sm">
                                          Cancel
                                        </button>
                                        <button
                                          class="btn btn-success text-white btn-sm"
                                        >
                                          Done
                                        </button>
                                      </div>
                                    </div> -->
                                  </div>
                                </b-card-text></b-tab
                              >
                              <b-tab title="Right Side Expression"
                                ><b-card-text
                                  >
                                    <div class="">
                                    <div class="row mx-0 mb-2">
                                      <div class="col-sm-12 mb-1">
                                        <div class="form-group row mx-0">
                                          <label
                                            for="rightSideDescription"
                                            class="col-sm-2 col-form-label"
                                            >Description</label
                                          >
                                          <div class="col-sm-10">
                                            <input
                                              type="text"
                                              class="form-control"
                                              id="rightSideDescription"
                                              placeholder v-model="frmModel.rightSide.description"
                                            />
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div class="row mx-0 mb-2">
                                      <div class="col-sm-12 mb-1">
                                        <div class="form-group row mx-0">
                                          <!-- <label
                                            for="indicatorTypeName"
                                            class="col-sm-2 col-form-label"
                                            >Select Elements</label
                                          > -->
                                          <div class="col-sm-12">
                                            <div id="accordion">
                                              <div class="card rounded-0">
                                                <div
                                                  class=""
                                                  id="headingOne"
                                                  data-toggle="collapse"
                                                  data-target="#collapseOne"
                                                  aria-expanded="true"
                                                  aria-controls="collapseOne"
                                                >
                                                  <h5 class="mb-0">
                                                    <button
                                                      class="btn btn-light btn-block text-left bg_f4" style="border: 1px solid #ddd;"
                                                    >
                                                      Data Element
                                                    </button>
                                                  </h5>
                                                </div>

                                                <div
                                                  id="collapseOne"
                                                  class="collapse show"
                                                  aria-labelledby="headingOne"
                                                  data-parent="#accordion"
                                                >
                                                  <div
                                                    class="card-body pt-1 pb-0 px-0 rounded-0"
                                                  >
                                                    <div class="row">
                                                      <div class="col-sm-5">
                                                        <div class="row">
                                                          <div class="col-12 pr-0">
                                                            <div class="py-3 px-2" style="border-right:1px solid #ddd;">
                                                              <b-badge
                                                                variant="light"
                                                                class="px-3 mx-1" @click="addElemDenom('(','(')"
                                                                >(</b-badge
                                                              >
                                                              <b-badge
                                                                variant="light"
                                                                class="px-3 mx-1" @click="addElemDenom(')',')')"
                                                                >)</b-badge
                                                              >
                                                              <b-badge
                                                                variant="light"
                                                                class="px-3 mx-1" @click="addElemDenom('*','*')"
                                                                >*</b-badge
                                                              >
                                                              <b-badge
                                                                variant="light"
                                                                class="px-3 mx-1" @click="addElemDenom('/','/')"
                                                                >/</b-badge
                                                              >
                                                              <b-badge
                                                                variant="light"
                                                                class="px-3 mx-1" @click="addElemDenom('+','+')"
                                                                >+</b-badge
                                                              >
                                                              <b-badge
                                                                variant="light"
                                                                class="px-3 mx-1" @click="addElemDenom('-','-')"
                                                                >-</b-badge
                                                              >
                                                              <b-badge
                                                                variant="light"
                                                                class="px-3 mx-1" @click="addElemDenom('[Days]','[Days]')"
                                                                >Days</b-badge
                                                              >
                                                            </div>
                                                          </div>
                                                          <div class="col-12 pr-0">
                                                            <div class="p-3" style="border-top:1px solid #ddd; border-right:1px solid #ddd;">
                                                              <textarea class="expressionBuilder form-control" v-model="denomExpressionBuilder">
                                                              </textarea>
                                                              <div class="alertSection mt-3">
                                                                <b-alert show variant="success">Expression is <b>Valid</b></b-alert>
                                                                <b-alert show variant="danger">Expression is <b>not well-formed </b></b-alert>
                                                              </div>
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                      <div class="col-sm-7">
                                                        <div
                                                          class="swipTextWrap"
                                                        >
                                                        <div class="form-group has-search mt-3 w-100">
                                                            <span class="fa fa-search form-control-feedback"></span>
                                                            <input type="text" class="form-control" placeholder="Search" v-model="serachoptionslist">
                                                          </div>
                                                        <select
                                                          multiple   class="form-control multiSelectOption border border-0 mb-2 px-0" >

                                                          <template v-for="elem,i in dataElementList">
                                                          <option :value="elem.id" @click="addElemDenom(elem.id,elem.displayName,'DataElem')">
                                                            {{elem.displayName}}
                                                          </option>
                                                        </template>
                                                        </select>
                                                          <!-- <a
                                                            class="text-success checkValid"
                                                            >Valid</a
                                                          > -->
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <!-- <div class="row mx-0 mb-2">
                                      <div
                                        class="justify-content-end d-flex w-100"
                                      >
                                        <button class="btn btn-sm">
                                          Cancel
                                        </button>
                                        <button
                                          class="btn btn-success text-white btn-sm"
                                        >
                                          Done
                                        </button>
                                      </div>
                                    </div> -->
                                  </div>
                                  </b-card-text
                                ></b-tab
                              >
                            </b-tabs>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-12">
            <div class="bottomSubmitbtn float-right mb-4">

              <button class="btn btn-newprimary" @click="updateInd" v-if="frmModel.id">
                Update
                <i
                  class="fa fa-angle-double-right pl-2 text-white"
                  aria-hidden="true"
                ></i>
              </button>
              <button class="btn btn-newprimary" @click="submitInd" v-else>
                Save
                <i
                  class="fa fa-angle-double-right pl-2 text-white"
                  aria-hidden="true"
                ></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <training-footer></training-footer> -->
  </div>
</template>
<script>
import HeaderNew from "../components/layout/HeaderNew";
import trainingFooter from "../components/trainingFooter";
import ApiServices from "../service/ApiServices";
import swal from 'sweetalert2';
window.Swal = swal;

export default {
  components: {
    HeaderNew,
    trainingFooter
  },
  data() {
    return {
      showIndForm:false,
      userProfile: "",
      baseUrl: "http://localhost:8080/dhis/",
      dashboardUrl: "api/apps/Avenir-Generic/index.html#/",
      operandList: [
        { value: null, text: "Please select operator"},
        { value: "equal_to", text: "Equal to" },
        { value: "not_equal_to", text: "Not equal to" },
        { value: "greater_than", text: "Greater than" },
        { value: "greater_than_or_equal_to", text: "Greater than or equal to" },
        { value: "less_than", text: "Less than" },
        { value: "less_than_or_equal_to", text: "Less than or equal to" }
      ],
      perPage: 6,
      currentPage: 1,
      allAppsList: [],
      allAlertList:[],
      searchName: "",
      isView: "list",
      allAppsListLen: 0,
      dataElementList:[],
      indicatorTypes:[],
      expressionBuilder:"",
      expressionBuilderHidden:"",
      denomExpressionBuilder:"",
    //  indicatorTypeList:[],
    periodType:'Monthly',
    periodTypeList:[
      {'value':"Monthly",'text':"Monthly"},
      {'value':"Yearly",'text':"Yearly"},
      {'value':"Quaterly",'text':"Quaterly"}],
      denomExpressionBuilderHidden:"",
      frmModel:{"importance":"MEDIUM","operator":"not_equal_to","leftSide":{"missingValueStrategy":"NEVER_SKIP","description":"","expression":""},"rightSide":{"missingValueStrategy":"NEVER_SKIP","description":"","expression":""},"periodType":"Monthly","name":""}
    };
  },
  computed: {

      // indicatorTypeList: function() {
      //   let typeArr = this.indicatorTypes
      //
      //   var arr = [];
      //   var obj = { value: "", text: "Select Indicator Type" };
      //   arr.push(obj);
      //   typeArr.forEach((type, ind) => {
      //     var obj = { value: "", text: "" };
      //     obj.value = type.id;
      //     obj.text = type.displayName;
      //     arr.push(obj);
      //   });
      //   console.log(arr);
      //   return arr;
      // },
    appsList() {
      let filteredApps = this.allAppsList.filter(
        a =>
          (a.appName &&
            a.appName.toLowerCase().includes(this.searchName.toLowerCase())) ||
          (a.createdBy &&
            a.createdBy
              .toLowerCase()
              .includes(this.searchName.toLowerCase())) ||
          (a.updatedBy &&
            a.updatedBy.toLowerCase().includes(this.searchName.toLowerCase()))
      );
      // console.log("filteredApps",filteredApps)
      this.allAppsListLen = filteredApps.length;
      return filteredApps.slice(
        (this.currentPage - 1) * this.perPage,
        this.currentPage * this.perPage
      );
    },
    rows() {
      return this.allAppsList.length;
    }
  },
  watch:{
    expressionBuilder(newv){
      if(newv == '')
      this.expressionBuilderHidden=newv;
    },
    expressionBuilderHidden(newVal)
    {
      console.log("Call api",newVal);
      if(newVal != '')
      ApiServices.RestPostCall('api/indicators/expression/description',newVal,'text/plain').then(res=>{
        console.log(res);
      })
    },
    denomExpressionBuilder(newv){
        if(newv == '')
      this.denomExpressionBuilderHidden=newv;
    },
    denomExpressionBuilderHidden(newVal)
    {
      console.log("Call denom api",newVal);
        if(newVal != '')
      ApiServices.RestPostCall('api/indicators/expression/description',newVal,'text/plain').then(res=>{
        console.log(res);
      })
    },
  },
  methods: {
    showForm(){

      this.showIndForm = true;
      this.frmModel = {"importance":"MEDIUM","operator":"not_equal_to","leftSide":{"missingValueStrategy":"NEVER_SKIP","description":"","expression":""},"rightSide":{"missingValueStrategy":"NEVER_SKIP","description":"","expression":""},"periodType":"Monthly","name":""}
      this.expressionBuilderHidden = ''
       this.denomExpressionBuilderHidden = ''
       this.expressionBuilder =  "";
       this.denomExpressionBuilder = "";
       this.indicatorType =''
    },
    editind(name,id){
        this.showIndForm =true;
      https://uatfppnepal.duredemos.com/service/api/29/validationRules/VUfMxiTLKgg?fields=%3Aall%2CattributeValues%5B%3Aall%2Cattribute%5Bid%2Cname%2CdisplayName%5D%5D
        ApiServices.RestGetCall('api/validationRules/'+id+'?fields=%3Aall%2CattributeValues%5B%3Aall%2Cattribute%5Bid%2Cname%2CdisplayName%5D%5D').then(res1=>{
          console.log(res1);
          if(res1.data!= undefined && res1.data.httpStatusCode != undefined && res1.data.httpStatusCode == 404){
            Swal.fire({
              text: res1.data.message,
            //  icon: 'warning',
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33'
            })
          }
          else {
            let res = res1
          this.frmModel =res;
          console.log(this.frmModel);
          this.expressionBuilderHidden = this.frmModel.leftSide.expression
           this.denomExpressionBuilderHidden = this.frmModel.rightSide.expression
           this.expressionBuilder = this.getEquestion(this.frmModel.leftSide.expression);
           this.denomExpressionBuilder = this.getEquestion(this.frmModel.rightSide.expression);
           //this.indicatorType = this.frmModel.indicatorType.id
         }
        });
        // ApiServices.RestGetCall('api/indicatorTypes?fields=id%2CdisplayName%2Cname&paging=false').then(res=>{
        //   console.log(res);
        //   this.indicatorTypes = res.indicatorTypes
        // });
    },
    getEquestion(expression){
     var newexp =expression;
     console.log(expression);
     console.log(this.dataElementList);
     if(expression != ''){
        this.dataElementList.forEach(obj =>{
          if(expression.search("#{"+obj.id+"}") != -1){
            newexp= newexp.replace("#{"+obj.id+"}", obj.displayName);
          }
        })
      }
      console.log(newexp);
        return newexp;
    },
    updateInd(){
      this.frmModel.leftSide.expression = this.expressionBuilderHidden
      this.frmModel.rightSide.expression = this.denomExpressionBuilderHidden
        var formData = this.frmModel;
        console.log(formData);
      ApiServices.RestPutCall('api/validationRules/'+formData.id+'?mergeMode=REPLACE',formData).then(res=>{
        console.log(res);
        if(res.httpStatusCode == 200)
        {
        this.frmModel = {"importance":"","operator":"not_equal_to","leftSide":{"missingValueStrategy":"NEVER_SKIP","description":"","expression":""},"rightSide":{"missingValueStrategy":"NEVER_SKIP","description":"","expression":""},"periodType":"","name":""}
          this.expressionBuilderHidden = ''
           this.denomExpressionBuilderHidden = ''
           this.expressionBuilder =  "";
           this.denomExpressionBuilder = "";
           this.showIndForm =false;
          Swal.fire({
            text: "Alert updated successfully",
            icon: 'warning',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33'
          }).then(function() {
            window.location = "#/alertAdd";
          });
        }
      });
    },
    submitInd(){
      this.frmModel.leftSide.expression = this.expressionBuilderHidden
      this.frmModel.rightSide.expression = this.denomExpressionBuilderHidden
    //  this.frmModel.indicatorType= {id:this.indicatorType}
      var formData = this.frmModel;
        ApiServices.RestPostCall('api/validationRules',formData).then(res=>{
          console.log(res);
          if(res.httpStatusCode == 201)
          {
            this.frmModel= {"importance":"","operator":"not_equal_to","leftSide":{"missingValueStrategy":"NEVER_SKIP","description":"","expression":""},"rightSide":{"missingValueStrategy":"NEVER_SKIP","description":"","expression":""},"periodType":"","name":""}
            this.expressionBuilderHidden = ''
             this.denomExpressionBuilderHidden = ''
             this.expressionBuilder =  "";
             this.denomExpressionBuilder = "";
             this.indicatorType =''
             this.showIndForm =false;
            Swal.fire({
              text: "Alert created successfully",
              icon: 'warning',
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33'
            }).then(function() {
              window.location = "#/alertAdd";
            });
          }
          else {
            Swal.fire({
              text: "Something went wrong. Please try again",
              icon: 'warning',
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33'
            }).then(function() {
              window.location = "#/alertAdd";
            });
          }
        });
    },
    addElem(elemId,elemName,typeSt=null){
     this.expressionBuilder = this.expressionBuilder + elemName
       if(typeSt == "DataElem"){
     this.expressionBuilderHidden =this.expressionBuilderHidden +'#{'+elemId+'}'
        }
        else {
       this.expressionBuilderHidden =this.expressionBuilderHidden +elemId
     }
    },
    addElemDenom(elemId,elemName,typeSt=null){
     this.denomExpressionBuilder = this.denomExpressionBuilder + elemName
       if(typeSt == "DataElem"){
     this.denomExpressionBuilderHidden =this.denomExpressionBuilderHidden +'#{'+elemId+'}'
        }
        else {
       this.denomExpressionBuilderHidden =this.denomExpressionBuilderHidden +elemId
     }
    },
    gotoApp(appId, appUserId) {
      window.open(
        `http://localhost:8080/#/?appId=${appId}&appUserId=${appUserId}`,
        "_blank"
      );
    },
    logout() {
      //dhis-web-commons-security/logout.action
      localStorage.removeItem("userProfile");
      localStorage.removeItem("loggedInUserId");
      ApiServices.RestGetCall(
        "dhis-web-commons-security/logout.action",
        {}
      ).then(res => {
        console.log(res);
      });
      //window.open('http://intraavenir.duredemos.com/service/dhis-web-commons-security/logout.action', '_blank');
      this.$router.push("/");
    },
    getList(){
        ApiServices.RestGetCall('api/dataElementOperands?filter=dataElement.domainType:eq:AGGREGATE&fields=id%2CdisplayName&totals=true',{}).
        then(res => {
          console.log(res);
          if(res.dataElementOperands != undefined)
          this.dataElementList = res.dataElementOperands;
        });
        // ApiServices.RestGetCall('api/indicatorTypes?fields=id%2CdisplayName%2Cname&paging=false').then(res=>{
        //   console.log(res);
        //   this.indicatorTypes = res.indicatorTypes
        // });

    },
    getAllApps() {
      console.log(this.$root);
      this.$root.loading = true;
      ApiServices.getAllKeys()
        .then(async response => {
          console.log(response);
          let filteredApps = [];

          response.data.forEach(a => {
            let keyName = a.split("_");
            if (a.includes("applicationModule") && keyName.includes("en")) {
              filteredApps.push(a);
            }
          });

          await ApiServices.RestGetCall(
            "/api/avenir/training/getTrainingApps"
          ).then(response => {
            console.log("Training response", response.trainingApp);
            response.trainingApp.forEach(t => {
              this.allAppsList.push(t);
            });
          });
          if (filteredApps.length) {
            filteredApps.forEach(async (f, i) => {
              let appResponse = await ApiServices.getSavedConfig(f);
              this.allAppsList.push(appResponse.data);
              if (this.allAppsList.length === filteredApps.length) {
                this.$root.loading = false;
                console.log("apps List", this.allAppsList);
              }
            });
          }
        })
        .catch(res => (this.$root.loading = false));
    },
    getAlertList(){
    ApiServices.RestGetCall('api/29/validationRules?filter=name:ne:default&fields=displayName%2CshortName%2Cid%2ClastUpdated%2Ccreated%2CdisplayDescription%2Ccode%2CpublicAccess%2Caccess%2Chref%2Clevel%2CdisplayName%2Cimportance%2CperiodType%2CpublicAccess%2ClastUpdated%2C&order=displayName%3AASC').then(response => {
      console.log(response);
      this.allAlertList = response.validationRules
    });
    }
  },
  mounted() {
    this.userProfile = JSON.parse(localStorage.getItem("userProfile"));
    this.baseUrl = ApiServices.getBaseUrl();
    this.dashboardUrl = this.baseUrl + this.dashboardUrl;
    //this.getAllApps();
    this.getAlertList();
    this.getList();
  }
};
</script>
<style scoped lang="scss">
.mainWrap-bg {
  background-color: #f4f4f4 !important;
  background-image: none;
  /* background-size: cover;
  background-position: center; */
  min-height: 100vh;
  /* padding: 20px 40px; */
  padding: 10px 20px;
}
.maindivWrap {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}

.body {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 80vh;
}

.form-control {
  background-color: transparent !important;
}
.tableCard {
  .table {
    thead {
      tr {
        background: #2e3f53;
        th {
          color: #fff;
        }
      }
    }
  }
}
.addIndicatorTypebtn {
  position: relative;
  text-align: left;
  font-weight: 200 !important;
  border-radius: 2px !important;
  font-size: 0.875rem;
}
.addIndicatorTypebtn:hover {
  position: relative;
  text-align: left;
  font-weight: 200 !important;
  border-radius: 2px !important;
  font-size: 0.875rem;
}
.addIndicatorTypebtn::after {
  position: absolute;
  right: 15px;
  top: 15px;
}
.multiSelectOption option {
  font-size: 0.875rem;
    background: #f5f5f5;
    padding: 10px 12px;
    margin-bottom: 1%;
}
.swipTextWrap {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.checkValid {
  text-align: left;
  width: 100%;
  position: relative;
  bottom: -57px;
  font-weight: 600;
}
textarea {
  width: 100%;
  height: 200px !important;
}
.has-search .form-control {
    padding-left: 2.375rem;
}

.has-search .form-control-feedback {
    position: absolute;
    z-index: 2;
    display: block;
    width: 2.375rem;
    // height: 2.375rem;
    // line-height: 2.375rem;
    text-align: center;
    pointer-events: none;
    color: #aaa;
}
select:-internal-list-box:focus option:checked:hover{
  background-color: -internal-light-dark(rgb(206, 206, 206), rgb(84, 84, 84)) !important;
    color: -internal-light-dark(rgb(16, 16, 16), rgb(255, 255, 255)) !important;
}
</style>
